import { Form, Select, Skeleton, type SelectProps } from "antd";
import React, { useMemo } from "react";
import { type Rule } from "antd/es/form";
import { type FilterFunc } from "rc-select/lib/Select";
import { type DefaultOptionType } from "antd/es/cascader";
import { type Services } from "../../generated-axios-client";
import type { IntlShape } from "@formatjs/intl";

export const serviceSelectOptions = (serviceItems: Services[]) => {
  const serviceOptions = serviceItems.map((item) => ({
    key: item.id,
    value: item.id,
    label: item.name,
  }));

  return serviceOptions;
};

const serviceSearchHandler: FilterFunc<DefaultOptionType> = (input, option) => {
  const search = input.toLowerCase();
  const value = option?.label?.toString().toLowerCase?.() ?? "";

  return value.includes(search);
};

type ServiceSelectFormItemProps = {
  intl: IntlShape;
  serviceItems: Services[];
  rules?: Rule[];
  placeholder?: string | boolean;
  selectProps?: SelectProps<string>;
};

export const ServiceSelectorFormItem = (props: ServiceSelectFormItemProps) => {
  const { intl, serviceItems, rules = [], placeholder = false, selectProps } = props;

  const options = useMemo(() => serviceSelectOptions(serviceItems), [serviceItems]);

  if (!serviceItems) {
    return <Skeleton />;
  }

  return (
    <Form.Item
      name="service"
      label={intl.formatMessage({ id: "filter_label_service" })}
      rules={[
        {
          required: true,
          message: intl.formatMessage({ id: "validation_message_ticket_service" }),
        },
      ]}
    >
      <Select
        placeholder={placeholder}
        showSearch={true}
        options={options}
        filterOption={serviceSearchHandler}
        {...selectProps}
      />
    </Form.Item>
  );
};
